import React from 'react';

export default class Droppable extends React.Component<*> {
  constructor(props) {
    super(props);
    this.state = {
      over: false,
    };
    this.droppable = React.createRef();
  }

  componentDidMount() {
    // TODO: Listen for window resize?
    let node = this.droppable.current;
    this.position = {
      top: node.offsetTop + 5,
      left: node.offsetLeft + 5,
      right: node.offsetLeft + node.offsetWidth - 5,
      bottom: node.offsetTop + node.offsetHeight - 5,
    };
  }

  render(): React.Element<*> {
    const { children, className } = this.props;
    const { over } = this.state;

    let classes = 'Droppable';
    if (className) {
      classes += ` ${className}`;
    }
    if (over) {
      classes += ' over';
    }
    return (
      <div
        ref={this.droppable}
        className={classes}
        onDrop={this.onDrop}
        onDragOver={this.onDragOver}
        onDragEnter={this.onDragEnter}
        onDragLeave={this.onDragLeave}
        onDragExit={this.onDragLeave}
      >
        {children}
      </div>
    );
  }

  onDragEnter = e => {
    e.preventDefault();
    const { onDragEnter } = this.props;
    const { over } = this.state;
    if (over) {
      return;
    }

    if (typeof onDragEnter === 'function') {
      onDragEnter(e);
    }

    this.setState({ over: true });
  };

  onDragLeave = e => {
    e.preventDefault();
    const { onDragLeave } = this.props;

    let over = true;

    if (e.clientX <= this.position.left || e.clientX >= this.position.right) {
      over = false;
    }

    if (e.clientY <= this.position.top || e.clientY >= this.position.bottom) {
      over = false;
    }

    if (over) {
      return;
    }

    this.setState({ over: false });
    if (typeof onDragLeave === 'function') {
      onDragLeave(e);
    }
  };

  onDrop = e => {
    e.preventDefault();
    this.setState({ over: false });

    const { onDrop } = this.props;
    const data = this.allowed(e.dataTransfer.getData('text'));

    if (!data) {
      return;
    }

    if (typeof onDrop === 'function') {
      onDrop({ [data.type]: data.data }, e);
    }
  };

  onDragOver(e) {
    e.preventDefault();
  }

  allowed(data) {
    const { types = [] } = this.props;

    try {
      const _data = JSON.parse(data);
      const { type } = _data || {};
      const isAllowed = types.indexOf(type);

      if (isAllowed >= 0) {
        return _data;
      }
    } catch (error) {
      console.warn(error);
      return false;
    }
  }
}
